export default __webpack_public_path__ + "static/dummy-blog-1-df1c06d1f85398345d3b3a3e2905737a.png";